<template>
  <div>
    <!-- <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          :disabled="assignEditorDisabled"
          class="success mr-1"
          fab
          x-small
          v-on="{ ...tooltip }"
          @click="assignEditor()"
        >
          <v-icon>mdi-account-edit-outline</v-icon>
        </v-btn>
      </template>
      <span>ASSIGN EDITOR</span>
    </v-tooltip> -->

    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-hover v-slot="{ hover }">
          <v-btn
            block
            height="80"
            class="mr-1"
            :elevation="hover ? 8 : 2"
            v-on="{ ...tooltip }"
            :disabled="assignEditorDisabled"
            @click="assignEditor()"
            style="background-color: #a5d6a7; color: #000"
          >
            <div class="d-flex flex-column align-center">
              <v-icon style="color: #000">mdi-account-edit-outline</v-icon>
              <span class="action-text" style="color: #000">ASSIGN EDITOR</span>
            </div>
          </v-btn>
        </v-hover>
      </template>
      <span>ASSIGN EDITOR</span>
    </v-tooltip>

    <!-- THE DIALOG BEGINS HERE -->
    <v-dialog persistent v-model="dialogAssignEditor" max-width="750px">
      <template v-if="editedCasefile">
        <v-card class="text-center">
          <v-card-title class="justify-center text-h5 grey lighten-2">
            <span class="text-h5">ASSIGN EDITOR</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="branch.brCode"
                    :items="sortedBranches"
                    item-text="name"
                    item-value="brCode"
                    :menu-props="{ maxHeight: '400' }"
                    label="BRANCH"
                    hint="Select Branch"
                    persistent-hint
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="editedCasefile.editor"
                    :items="sortedEditorsByBranch(branch.brCode)"
                    item-text="username"
                    item-value="id"
                    no-data-text="There is no Editor for the branch above"
                    :menu-props="{ maxHeight: '400' }"
                    label="EDITOR/ BRANCH CLERK / BRANCH MANAGER / CLERK / MANAGER"
                    hint="Assign Editor"
                    persistent-hint
                  ></v-select>
                </v-col>
                <!-- Editors:
              <span v-for="editor in editors" :key="editor.id">
                <pre>
            {{ editor.branches }}
              </pre
                >
              </span> -->
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              tile
              dark
              small
              @click="closeAssignEditorDialog"
              class="mt-3 mr-2 error"
              :disabled="isSubmitting"
            >
              Cancel
            </v-btn>
            <v-btn
              :disabled="isAddFileButtonDisabled || isSubmitting"
              tile
              small
              class="mt-3 success"
              @click="compAssignEditor"
              >Submit</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import CasefileDataService from "../../services/CasefileDataService";
import MailDataService from "../../services/MailDataService";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "AssignEditor",
  props: [
    "branches",
    "editors",
    "management",
    "insurer",
    "refType",
    "subRefTypes",
    "members",
  ],
  components: {},
  data() {
    return {
      dialogAssignEditor: false,
      branch: {
        name: "",
        brCode: "",
      },
      editedCasefile: null, // Local copy for editing
      isSubmitting: false,
    };
  },
  computed: {
    ...mapState(["caseState"]),
    sortedBranches() {
      // Only show branches the user has access to, sorted by name and uppercase
      const user = this.$store.state.auth.user;
      if (!user) return [];
      if (
        user.roles &&
        user.roles.some((role) => ["ADMIN", "MANAGER", "CLERK"].includes(role))
      ) {
        return this.branches
          .map((b) => ({
            ...b,
            name: b.name ? b.name.trim().toUpperCase() : "",
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
      }
      const userBranches = Array.isArray(user.branches)
        ? user.branches
        : [user.branches];
      return this.branches
        .filter((branch) =>
          userBranches.some(
            (userBranch) =>
              userBranch === branch.id ||
              userBranch === Number(branch.id) ||
              userBranch === String(branch.id)
          )
        )
        .map((b) => ({
          ...b,
          name: b.name ? b.name.trim().toUpperCase() : "",
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    sortedEditorsByBranch() {
      return (brCode) => {
        return this.editors
          .filter(
            (r) =>
              Array.isArray(r.branches) &&
              r.branches.some((i) => i.brCode === brCode)
          )
          .map((editor) => ({
            ...editor,
            username: editor.username
              ? editor.username.trim().toUpperCase()
              : "",
          }))
          .sort((a, b) => a.username.localeCompare(b.username));
      };
    },
    assignEditorDisabled() {
      return !(this.caseState.casefile.fileStatus == `PEDI` && this.management);
    },
    isAddFileButtonDisabled() {
      return !(
        this.branch.brCode &&
        this.editedCasefile &&
        this.editedCasefile.editor
      );
    },
  },
  watch: {
    assignEditor(val) {
      val || this.closeAssignEditorDialog();
    },
  },
  methods: {
    filterBranchName(item) {
      if (!item) return "TBA";
      const filteredbranch = this.branches.filter(
        (branch) => branch.id === item
      );
      return filteredbranch[0].name;
    },
    filterBranches(item) {
      return this.branches.filter((branch) => branch.id === item);
    },
    findBrcode(item) {
      if (!item) return "TBA";
      const filteredbranch = this.branches.filter(
        (branch) => branch.id === item
      );
      return filteredbranch.map((b) => b.brCode);
    },
    filterDept(item) {
      return this.refType.filter((dept) => dept.id === item);
    },
    filterSubDept(item) {
      return this.subRefTypes.filter((subRef) => subRef.id === item);
    },
    filterIns(item) {
      return this.insurer.filter((insurer) => insurer.id === item);
    },
    findUserEmail(item) {
      const user = this.members.filter((member) => member.id === item);
      return user[0] ? user[0].email : "sys.admin@associatedadjusters.com";
    },
    assignEditor() {
      // Clone casefile for local editing
      this.editedCasefile = JSON.parse(JSON.stringify(this.caseState.casefile));
      // Reset branch selection to match casefile (if exists)
      if (this.caseState.casefile.branch) {
        const branchObj = this.branches.find(
          (b) => b.id === this.caseState.casefile.branch
        );
        this.branch = branchObj
          ? { name: branchObj.name, brCode: branchObj.brCode }
          : { name: "", brCode: "" };
      } else {
        this.branch = { name: "", brCode: "" };
      }
      this.dialogAssignEditor = true;
    },
    compAssignEditor() {
      if (!this.editedCasefile) return;
      this.isSubmitting = true;
      const payload = {
        ...this.editedCasefile,
        editor: this.editedCasefile.editor,
        fileStatus: "EDAC",
        dateOfEdi: moment().format(),
        assignEdiBy: this.$store.state.auth.user.id,
      };
      CasefileDataService.update(this.caseState.casefile.id, payload)
        .then((response) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            color: "warning",
            text:
              (response && response.data && response.data.message) ||
              toString(),
          });
          // Defensive: ensure payload.editor is not null before assigning
          this.caseState.casefile = {
            ...this.caseState.casefile,
            ...payload,
            editor: payload.editor || null,
          };
          this.closeAssignEditorDialog();
        })
        .catch((e) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            text:
              (e.response && e.response.data && e.response.data.message) ||
              e.message ||
              toString(),
          });
        })
        .then(() => {
          // Defensive: check for nulls before accessing properties
          const deptObj =
            this.filterDept(this.caseState.casefile.refType)[0] || {};
          const subDeptObj =
            this.filterSubDept(this.caseState.casefile.subRefType)[0] || {};
          const branchObj =
            this.filterBranches(this.caseState.casefile.branch)[0] || {};
          const insurerObj =
            this.filterIns(this.caseState.casefile.insurer)[0] || {};
          const recipientEmail = this.findUserEmail(payload.editor);

          var dataEmail = {
            id: this.caseState.casefile.id,
            refType: deptObj.description || "",
            refTypeCode: deptObj.name || "",
            subRefType: subDeptObj.subCodeDesc || "",
            subRefCode: subDeptObj.subCode || "",
            branch: this.filterBranchName(this.caseState.casefile.branch),
            branchCode: branchObj.brCode || "",
            insurer: insurerObj.name || "",
            vehicleNo: (this.caseState.casefile.vehicleNo || "")
              .toLowerCase()
              .replace(/\s/g, ""),
            recipient: recipientEmail,
            createdBy: this.$store.state.auth.user.id,
          };
          MailDataService.editorAccept(dataEmail).then((response) => {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              color: "warning",
              text:
                (response && response.data && response.data.message) ||
                toString(),
            });
          });
          this.dataEmail = "";
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    closeAssignEditorDialog() {
      this.dialogAssignEditor = false;
      this.editedCasefile = null;
      this.branch = { name: "", brCode: "" };
    },
  },
};
</script>

<!-- NOTE: For express file movement (manager is also editor and wants to skip editor assignment/approval), use Assign Clerk instead of Assign Editor. -->
